import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import OrderForm from '../views/OrderForm.vue'
import Orders from '../views/Orders.vue'
import Login from '../views/Login.vue'
import SendersView from '../views/SendersView.vue'
import CurrencyView from '../views/CurrencyView.vue'
import store from '../store'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'currency',
    component: CurrencyView,
    meta: { requiresAuth: false }
  },
  {
    path: '/order/new',
    name: 'newOrder',
    component: OrderForm,
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      // Reset the current order to a new empty order
      store.commit('RESET_CURRENT_ORDER')
      next()
    }
  },
  {
    path: '/order/:id',
    name: 'order',
    component: OrderForm,
    meta: { requiresAuth: true }
  },
  {
    path: '/orders',
    name: 'orders',
    component: Orders,
    meta: { requiresAuth: true }
  },
  {
    path: '/senders',
    name: 'senders',
    component: SendersView,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { requiresAuth: false }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Track auth check status to prevent multiple simultaneous checks
let authCheckPromise: Promise<boolean> | null = null;

router.beforeEach(async (to, from, next) => {
  // Skip auth check for non-protected routes
  if (to.matched.some(record => record.meta.requiresAuth === false)) {
    // If already authenticated and trying to access login, redirect to orders
    if (to.path === '/login' && store.state.auth?.isAuthenticated) {
      next('/order/new')
    } else {
      next()
    }
    return
  }

  // If already authenticated, proceed
  if (store.state.auth?.isAuthenticated) {
    next()
    return
  }

  // Use existing auth check if one is in progress
  if (!authCheckPromise) {
    authCheckPromise = store.dispatch('auth/checkAuth')
      .finally(() => {
        authCheckPromise = null
      })
  }

  const isAuthenticated = await authCheckPromise
  
  if (isAuthenticated) {
    next()
  } else {
    next('/login')
  }
})

export default router
